export default "__VITE_ASSET__6a91627f__"